import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import WhitePopUpNoTitle from '../../shared/modal/whitePopUp/WhitePopUpNoTitle';

type YourStatsProps = {
  hide: boolean;
  userStats: {
    platformMinutes: number;
    mindfulMinutes: number;
    activeMinutes: number;
  };
};
export function YourStats({ hide, userStats }: YourStatsProps) {
  const { t } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalTextContent, setModalTextContent] = useState<{ title: string; text: string[] }>({
    title: '',
    text: [],
  });
  const buttonRef = useRef(null);

  const openModal = () => {
    setModalIsOpen(true);
    setModalTextContent({ title: t('S047'), text: [t('S130')] });
  };

  const modalClickHandler = () => {
    setModalIsOpen(false);
    buttonRef.current?.focus();
  };

  return (
    <>
      {modalIsOpen && (
        <WhitePopUpNoTitle
          returnFocus
          popupContents={modalTextContent}
          ctaBtn={t('T015')}
          handleSubmit={modalClickHandler}
          dialogTitle={t('modal.stats.explanation')}
        />
      )}
      <div id="your-stats" className={`rm-box ${hide ? 'mt' : ''} fs-exclude`}>
        <div className="profile-name left">
          {t('S047')}
          <button
            type="button"
            onClick={openModal}
            className="transparent-button icon-button"
            ref={buttonRef}
          >
            <span className="visuallyHidden">{t('open.modal.your.stats')}</span>
            <FontAwesomeIcon icon={faQuestionCircle} className="icon" />
          </button>
        </div>
        <div className="streaks-cont">
          <div className="streak-clmn-full">
            <StreakLine name={t('S048')} number={userStats.platformMinutes} />
            <StreakLine name={t('S049')} number={userStats.mindfulMinutes} />
            <StreakLine name={t('S050')} number={userStats.activeMinutes} />
          </div>
        </div>
      </div>
    </>
  );
}

function StreakLine({ name, number }) {
  return (
    <div className="streak-line" aria-label={`${name}  ${number}`} role="group">
      <div className="streak-name stats" aria-hidden="true">
        {name}
      </div>
      {formatNumber(number)}
    </div>
  );
}

const formatNumber = (number) => {
  // Format the number with commas
  if (number < 0 || number === null) number = 0;

  const formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // Split the formatted number into individual characters (digits and commas)
  const characters = formattedNumber.split('');

  return (
    <div className="profile-name left nm" aria-hidden="true">
      {characters.map((char, index) =>
        char === ',' ? (
          <span key={index}>,</span>
        ) : (
          <div className="scrolling-container">
            <div className="scrolling-number">
              <span key={char} className="current">
                {char}
              </span>
            </div>
          </div>
        )
      )}
    </div>
  );
};
